import React from 'react';
import styles from './Creativity.module.css';
import man from './images/Male Memojis (3).svg';
import man2 from './images/8 5.svg';
import man3 from './images/5 5.svg';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
    OptimizedMotion,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const Creativity: React.FC = () => {
    return (
        <section className={styles.problemSolvingSection}>
            <div className={styles.contentContainer}>
                <div className={styles.headerSection}>
                    <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                        <span className={styles.titleHighlight}>Creativity </span>that{' '}
                        <span className={styles.wrenchIcon}>📊</span> works smarter
                    </OptimizedMotionH1>
                    <OptimizedMotionP className={styles.subtitle} type="slide-left" delay={0.4}>
                        Marketing teams are buried under content chaos. From off-brand messaging and
                        scattered version control to sluggish approvals and missed launch windows,
                        the system is broken.
                    </OptimizedMotionP>
                </div>

                <div className={styles.painPointsSection}>
                    <div className={styles.painPointsGrid}>
                        <OptimizedMotion
                            className={styles.painPointItem}
                            type="slide-left"
                            delay={0.2}
                        >
                            <div className={styles.iconContainer}>
                                <img src={man} />
                            </div>
                            <div className={styles.painPointContent}>
                                <h3 className={styles.painPointTitle}>Spark ideas on demand</h3>
                                <p className={styles.painPointDescription}>
                                    The Inspiration Engine suggests campaign themes from trends and
                                    competitors. One click creates ideas for blogs, socials, or
                                    emails.
                                </p>
                            </div>
                        </OptimizedMotion>

                        {/* Workflow Chaos */}
                        <OptimizedMotion
                            className={styles.painPointItem}
                            type="slide-down"
                            delay={0.4}
                        >
                            <div className={styles.iconContainer}>
                                <img src={man2} />
                            </div>
                            <div className={styles.painPointContent}>
                                <h3 className={styles.painPointTitle}>AI-Assisted craftsmanship</h3>
                                <p className={styles.painPointDescription}>
                                    Copywriters get predictive completions, designers expand or
                                    remix visuals. AI handles the grunt work so you focus on ideas.
                                </p>
                            </div>
                        </OptimizedMotion>

                        {/* Approval Bottlenecks */}
                        <OptimizedMotion
                            className={styles.painPointItem}
                            type="slide-right"
                            delay={0.6}
                        >
                            <div className={styles.iconContainer}>
                                <img src={man3} />
                            </div>
                            <div className={styles.painPointContent}>
                                <h3 className={styles.painPointTitle}>Tailored to your industry</h3>
                                <p className={styles.painPointDescription}>
                                    30+ ready layouts—from SaaS decks to promo carousels. Customize
                                    fast, approve, and auto-schedule across channels.
                                </p>
                            </div>
                        </OptimizedMotion>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Creativity;
